import { ApplicationRoles } from "./user-roles"

export interface AccessControl {
    userManagement: boolean,
    addUser: boolean,
    editUser: boolean,
    deleteUser:boolean,
    allowChangingUserStatus:boolean,
    invitationManagement: boolean,
    bbInvitaitons: boolean,
    addBBInvitation: boolean,
    editBBInvitation: boolean,
    llttfInvitations: boolean,
    addLLTTFInvitation: boolean,
    editLLTTFInvitation: boolean,
    courseManagement: boolean
    tags: boolean,
    addTags:boolean,
    editTags:boolean,   
    materials: boolean,
    addMaterials:boolean,
    editMaterials:boolean,
    courses: boolean,
    addCourse:boolean,
    editCourse:boolean,
    reporting: boolean
    orgManagement: boolean,
    canAddBBUsers: boolean,
    canAddLLTTFUsers: boolean,
    isParticipantBBCoached:boolean,
    isParticipantLLTTFCoached:boolean,
    isParticipantBBSelfGuided:boolean,
    participantLastActiveRole:ApplicationRoles|null,
    emailQueue:boolean,
    roleOnboardingManagement:boolean,
    /** DevAdmin only: allow changing a user's email on edit-user. */
    canEditEmail:boolean,
    /** DevAdmin only: allow bulk-importing Course/Material metadata from a spreadsheet. */
    canBulkImport:boolean
}

export function AccessControlDefaultValues(): AccessControl {
    return {
        userManagement: false,
        addUser: false,
        editUser: false,
        deleteUser:false,
        allowChangingUserStatus:false,
        invitationManagement: false,
        bbInvitaitons: false,
        addBBInvitation: false,
        editBBInvitation: false,
        llttfInvitations: false,
        addLLTTFInvitation: false,
        editLLTTFInvitation: false,
        courseManagement: false,
        tags: false,
        addTags: false,
        editTags: false,
        materials: false,
        addMaterials: false,
        editMaterials: false,
        courses: false,
        addCourse: false,
        editCourse:false,
        reporting: false,
        orgManagement: false,
        canAddBBUsers: false,
        canAddLLTTFUsers: false,
        isParticipantBBCoached: false,
        isParticipantLLTTFCoached: false,
        isParticipantBBSelfGuided: false,
        participantLastActiveRole:null,
        emailQueue: false,
        roleOnboardingManagement: false,
        canEditEmail: false,
        canBulkImport: false
    }
}